import React, { Component } from "react";
import Card from "Utils/Cards/Card";
import { DetalleCierreContent } from "./components/DetalleCierreContent";
import "../../styles/CierresMensuales.css";
import "../../styles/ComparativoMensualProduccion.css";
// los totales de los cierres de almacén se reutilizan tal cual, con los
// estilos de su propio módulo
import "../../../../InventariosAlmacen/components/Existencia/styles/Existencia.css";

class DetalleCierreMensualProduccion extends Component {
    regresar = () => {
        this.props.history.goBack();
    };

    render() {
        return (
            <div
                className="mb-4 col-12"
                style={{ maxWidth: "91.5vw", margin: "auto" }}
            >
                <Card
                    icon="produccion_activo"
                    titulo="Cierre mensual de producción"
                    subtitulo="Detalle del cierre registrado"
                    noBorder
                >
                    <DetalleCierreContent
                        cierreId={this.props.match.params.id}
                        regresar={this.regresar}
                    />
                </Card>
            </div>
        );
    }
}

export default DetalleCierreMensualProduccion;
